import {
  FiBarChart2,
  FiBookOpen,
  FiCompass,
  FiHelpCircle,
  FiHome,
  FiShuffle,
  FiUsers,
} from "react-icons/fi";
import type { IconType } from "react-icons";
import type { MessageId } from "@/i18n/catalogs/en";

export interface NavigationItem {
  icon: IconType;
  labelId: MessageId;
  path: string;
}

export const authenticatedNavigation: readonly NavigationItem[] = [
  { icon: FiHome, labelId: "common.navigation.today", path: "/dashboard" },
  { icon: FiBookOpen, labelId: "common.navigation.library", path: "/books" },
  { icon: FiShuffle, labelId: "common.navigation.nextBook", path: "/next-book" },
  { icon: FiBookOpen, labelId: "common.navigation.journal", path: "/reading" },
  { icon: FiBarChart2, labelId: "common.navigation.insights", path: "/stats" },
  { icon: FiCompass, labelId: "common.navigation.discover", path: "/discover" },
  { icon: FiUsers, labelId: "common.navigation.community", path: "/community" },
  { icon: FiHelpCircle, labelId: "common.navigation.help", path: "/help" },
];
